export default __webpack_public_path__ + "dbc8de47ea771b5966e914fb99232191.svg";